import script from "./Operate.vue?vue&type=script&setup=true&lang=js"
export * from "./Operate.vue?vue&type=script&setup=true&lang=js"

import "./Operate.vue?vue&type=style&index=0&id=031ff994&lang=css"

const __exports__ = script;

export default __exports__